import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthStore } from '@webapp/shared';

/**
 * Route-match guard that selects the player route tree for player-only users.
 *
 * @returns Whether the current user is a player-only user.
 */
export const playerCanMatchFn: CanMatchFn = () => {
  const authStore = inject(AuthStore);

  return authStore.isPlayer();
};
